import React from 'react';
import { getCaptchaSourcePageFromUrl } from '../../captcha/captchaUtils';
import { getPageName } from '../../utils/pageName';
import { getParametersFromUrl } from '../../utils/url-utils/urlUtils';
import { withSignUp } from './SignUpContext';
import { doctrineAnalytics } from '../../utils/analyticsUtils';

type Props = {
  children: React.ReactNode;
  saveSource: Function;
};

export class RawSignUpContainer extends React.Component<Props> {
  componentDidMount() {
    const urlParameters = getParametersFromUrl(window.location.href);
    const source = urlParameters.source ? urlParameters.source : 'Direct';
    let sourcePage;
    const pageName = getPageName();
    if (pageName === 'Captcha') {
      sourcePage = getCaptchaSourcePageFromUrl();
    } else {
      sourcePage = urlParameters.sourcePage
        ? urlParameters.sourcePage
        : 'Direct';
    }

    this.props.saveSource(source, sourcePage);

    doctrineAnalytics('Static SignupLoaded', {
      source,
      sourcePage,
    });
    if (window.fbq) {
      /* 
        Redundancy of this event with startProviders()
        component does not communicate with cookie acceptance
        triggers pixel if cookie has been accepted before reaching the page
      */
      window.fbq('track', 'ViewContent');
    }
  }

  render() {
    return this.props.children;
  }
}

export const SignUpContainer = withSignUp(RawSignUpContainer);
